/**
 *
 */

const SmoothScroll = require('./smoothscroll.js')
const SmoothPagesTransition = require('./smoothPagesTransition.js');
const Barba = require('barba.js');
const Menu = require('./menu.js');
const PreloadJs = require('preload-js');

class Bulb {

    constructor (){

        Utils.copyrights();
        Utils.debug('Bulb :: constructor');

        this.name = 'Bulb web starter';
        this.version = '0.1';
        this.dev = ((App.mode == 'dev') ? 1 : 0);
        this.lowVersion = false;
        this.options = {
            containerScrollable: '#appContent',
            itemsReveable: '.revealable',
            itemsParallaxable: '.parallaxable',
            itemsScrollable: '.elementor-widget:not(.elementor-widget-roxane-studycase, .elementor-widget-roxane-news), .headerPost, .works-header, .works-infos, .parallaxable, .headerPage, .section-bg, footer'
        };
        this.cssLoaded = [];
        this.easing = Expo.easeInOut;

        if( navigator.userAgent.match(/iPad/i) != null ){
            this.lowVersion = true;
        }

        this.smoothscroll = new SmoothScroll(this);
        this.smoothPagesTransitions = new SmoothPagesTransition(this);
        this.menu = new Menu(this);
        this.device = {};
        this.$spinner = $('.loader-spinner');
        this.openLoader();
        this.pageBg = false;
        this.reloadPageOnResize = true;
        //this.init();


        let preloadAssetsPromise = this.preloadAssets();
        let self = this;
        preloadAssetsPromise.then(function(){
            self.init()
            self.closeLoader();
        });

    }


    /**
     *
     * @returns {Promise}
     */
    preloadAssets(){

        var self = this;
        //Utils.debug('####### try to preloadAssets');

        return new Promise(function(resolve){

            let $preloadAssets = $('.barba-container').find('.preloadAssets');
            if($preloadAssets.length == 1){
                $preloadAssets = $preloadAssets.eq(0);
            } else if($preloadAssets.length > 1) {
                $preloadAssets = $preloadAssets.eq($preloadAssets.length-1);
            }

            if($preloadAssets.length){
                let toload = $.parseJSON($preloadAssets.html());
                //Utils.debug('####### preloadAssets');
                //Utils.debug(toload);
                var preload = new PreloadJs.LoadQueue(false);
                preload.on("complete", function(){  /*Utils.debug('####### Assets loaded');*/ resolve(true)});
                preload.loadManifest(toload);
            } else {
                //Utils.debug('####### no assets to preload');
                Utils.debug(self);
                resolve(true)
            }

        });

    }



    openLoader(){
        Utils.debug('Bulb :: Open loader');
        this.$spinner.css({
            'display' : 'block',
            'opacity' : 1
        });
        let TL = new TimelineMax();
        TL.to(this.$spinner, 1, {delay: 0.5, opacity: 1});
        TL.play();

    }

    closeLoader(){
        Utils.debug('Bulb :: Close loader');
        let TL = new TimelineMax();
        TL.to(this.$spinner, 0.5, { opacity: 0, display: 'none'});
        TL.play();

    }


    /**
     *
     */
    init(){
        Utils.debug('Bulb :: init');
        this.initEvents();
        this.smoothPagesTransitions.init();
        this.initDefaultEvents();
        $('#app').css('opacity', 1);

        if(this.lowVersion){
            $('body').addClass('lowVersion');
        }
    }


    /**
     *
     */
    initEvents(){
        Utils.debug('Bulb :: initEvents');
        let self = this;
        this.requestAnimationFrameHandler();
        this.resizeActions();

        this.windowWidth = $(window).width();


        $(window).on('resize orientationchange', function() {

            if ($(window).width() != self.windowWidth) {
                if(this.resizeTO) clearTimeout(this.resizeTO);
                this.resizeTO = setTimeout(function() {
                    $(this).trigger('resizeEnd');
                }, 500);
            }

        });


        // todo : lancement de cette event au resize
        $(window).on('resize orientationchange',{self: self}, self.resizeHandler) ;
        //$(window).bind('resizeEnd', {self: self}, self.resizeHandlerEnd) ;
    }

    resizeHandler(e){
        Utils.debug('Bulb :: resizeHandler');
        e.data.self.resizeActions();


        Utils.debug('e.data.self.reloadPageOnResize > ' + e.data.self.reloadPageOnResize);

        if(!e.data.self.reloadPageOnResize){
            return false;
        }

        if ($(window).width() != e.data.self.windowWidth) {
            $(e.data.self.options.containerScrollable).hide();
            e.data.self.openLoader();
            e.data.self.resizeActions();
            location.reload();
        }
    }

    resizeHandlerEnd(e){
        Utils.debug('Bulb :: resizeHandlerEnd');
        $(e.data.self.options.containerScrollable).hide();
        e.data.self.openLoader();
        location.reload();

    }



    /**
     * On mettra ici tout ce qui est propre au resize du site
     */
    resizeActions(){
        Utils.debug('Bulb :: resizeActions');
        this.smoothscroll.resizeContainer();
        $('body').trigger('bulb:resizeActions');

        var w = Verge.viewportW();

        this.device.landscape = false;

        this.device.isXl = false;
        this.device.isLg = false;
        this.device.isMd = false;
        this.device.isSm = false;
        this.device.isXs = false;


        this.device.isDesktop = false;
        this.device.isTablet = false;

        this.device.isIpad = false;
        if( navigator.userAgent.match(/iPad/i) != null ){
            this.device.isIpad = true;
        }


        if(w >= 1440){
            this.device.isXl = true;
            this.device.isDesktop = true;
        } else if(w >= 1200){
            this.device.isLg = true;
            this.device.isDesktop = true;
        } else if(w >= 1024){
            this.device.isMd = true;
            this.device.isTablet = true;
        } else if(w >= 640){
            this.device.isSm = true;
        } else if(w < 640){
            this.device.isXs = true;
        }


        if(window.innerWidth > window.innerHeight){
            this.device.landscape = true;
        }

        if((this.device.isSm || this.device.isXs) && this.device.landscape){
            $('body').addClass('mobileLandscape');
        } else {
            $('body').removeClass('mobileLandscape');
        }


        // Gestion des arrondis sur l'overlay du menu

        /*
        let $overlay = $('.mainMenu-overlay');
        let $overlayW = $overlay.innerWidth();
        let colwidth = Math.round($overlayW / 8);
        $overlay.find('> span').css('width', colwidth);
        $overlay.find('> span:first-child').css('width', colwidth*2);
        let gap = $overlayW - (colwidth*8);
        if(gap > 0){
            $overlay.find('> span:last-child').css('width', colwidth + gap);
        } else {
            $overlay.find('> span:last-child').css('width', colwidth - gap);
        }


        let $overlay = $('.mainMenu-overlay');
        let $overlayW = $overlay.innerWidth();
        let colwidth = Math.round($overlayW / 8);
        $overlay.find('> span').css('width', colwidth);
        $overlay.find('> span:first-child').css('width', colwidth*2);
        let gap = $overlayW - (colwidth*8);
        if(gap > 0){
            $overlay.find('> span:last-child').css('width', colwidth + gap);
        } else {
            $overlay.find('> span:last-child').css('width', colwidth - gap);
        }
*/

    }



    /**
     *
     */
    requestAnimationFrameHandler(){
        var _this = this;
        requestAnimationFrame(function(){_this.smoothscroll.scrolling()});
    }

    /**
     * Permet de charcher un css depuis le JS
     * impossible de charger deux fois la même url
     * @param url
     */
    loadCss(url){

        if(!_.contains(this.cssLoaded, url)){
            $('head').append('<link rel="stylesheet" type="text/css" href="'+url+'">');
        }
        this.cssLoaded.push(url);
    }


    loadPageAssets(){

    }






    /**
     * permet d'afficher dans la //console si le mode dev est activé
     * @param msg
     */
    debug(msg){
        if(this.dev)
            Utils.debug(msg);
    }

}

module.exports = Bulb;
